export const publicProfileActionKeys = {
  all: ["public-profile-actions"] as const,
  existingRequest: (targetUserId: string) =>
    [...publicProfileActionKeys.all, targetUserId, "existing-request"] as const,
  buddyStatus: (targetUserId: string) =>
    [...publicProfileActionKeys.all, targetUserId, "buddy-status"] as const,
};
